import { render, staticRenderFns } from "./tab7.vue?vue&type=template&id=06f4fa01&scoped=true&"
import script from "./tab7.vue?vue&type=script&lang=js&"
export * from "./tab7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f4fa01",
  null
  
)

export default component.exports